
const BASIC_URL ='https://navdaa-v2-backend.vercel.app'; //api deploy vercel
// const BASIC_URL = 'http://localhost:5000'; //api localhost
const API_URL = BASIC_URL + "/api";
const AUTH_API_URL =BASIC_URL + '/auth/login';
const API_ADMIN = API_URL + '/admin';
const API_TENTOR = API_URL + '/tentor';
const API = {
    BASIC_URL,
    API_URL,
    AUTH_API_URL,
    API_ADMIN,
    API_TENTOR
};

export default API;